// extracted by mini-css-extract-plugin
module.exports = {"blocked":"f_d","loader":"f_f","blog":"f_p","blog__categoryItem__wrap":"f_q"};